import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ScreeningConfigurationService {
  private baseUrl = `${environment.apiUrl}/api/ScreeningConfigurations`;

  constructor(private http: HttpClient) { }

  /**
   * Calls the filter-paginated endpoint
   * @param body The request body containing query and pagination
   * @returns Observable<any>
   */
  filterPaginated(body: { query?: { accountId?: string } }): Observable<any> {
    const accountId = localStorage.getItem('accountId');
    body.query = body.query || {};
    body.query.accountId = body.query.accountId || accountId || '';

    return this.http.post(`${this.baseUrl}/filter-paginated`, body);
  }

  monitoringAvailability(): Observable<any> {
    const accountId = localStorage.getItem('accountId') || '';
    return this.http.get(
      `${this.baseUrl}/accounts/${accountId}/monitoring/availability`
    );
  }
}
